<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div
      class="mt-5 d-flex justify-content-center"
      style="margin-top: 8% !important"
    >
      <div class="barras d-flex" style="width: 50%">
        <b-form-input
          @keydown.enter.native="obtenerUsuarioSistemaPortalAutoservicio()"
          class="input-filter"
          v-model="filtro.palabraClave"
          placeholder="Búsqueda de usuarios por nombre"
          type="text"
        >
        </b-form-input>
        <b-button
          class="btn_busqueda"
          variant="info"
          @click="obtenerUsuarioSistemaPortalAutoservicio()"
        >
          <div
            class="d-flex justify-content-center align-items-center"
            style="height: 100%"
          >
            <em class="buscar_svg" style="margin-top: 3px; height: 0.8em"> </em>
          </div>
        </b-button>
      </div>

      <b-button
        v-if="$localStorageService.can('PAS_01_portal_aut_usr_agreg')"
        variant="primary"
        v-b-tooltip.hover
        title="Agregar nuevo usuario"
        class="paddingbotones botonesAzulFuerteRedondo d-flex justify-content-center align-items-center mt-4 ml-4"
        responsive
        @click="agregar()"
        ><em class="usuario icon-boton"></em>
      </b-button>
    </div>

    <div>
      <b-table
        :items="datosTabla"
        :fields="fields"
        :per-page="registrosPorPagina"
        :current-page="paginaActual"
        responsive
        style="margin-top: 6%"
      >
        <template v-slot:cell(ACCIONES)="row">
          <b-button-group>
            <b-button
              title="Modificar usuario"
              size="sm"
              variant="outline-warning"
              @click="modificar(row.item)"
              v-if="$localStorageService.can('PAS_01_portal_aut_usr_edit')"
              ><em class="fa fa-pencil"></em
            ></b-button>
            <b-button
              v-if="
                !row.item.registroActivo &&
                $localStorageService.can('PAS_01_portal_aut_usr_inac')
              "
              title="Activar usuario"
              variant="outline-danger"
              size="sm"
              @click="activarDesactivarUsuario(row.item)"
              ><em class="fa fa-undo"></em
            ></b-button>
            <b-button
              v-else-if="$localStorageService.can('PAS_01_portal_aut_usr_inac')"
              title="Desactiva usuario"
              variant="outline-danger"
              size="sm"
              @click="activarDesactivarUsuario(row.item)"
            >
              <b-icon icon="trash-fill"></b-icon>
            </b-button>
          </b-button-group>
        </template>
      </b-table>
      <div v-if="loader" class="d-flex justify-content-center align-items-center">
        <div class="your-div">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
      </div>
      <b-pagination
        v-if="datosTabla !== undefined && datosTabla.length > 10"
        align="center"
        v-model="paginaActual"
        :total-rows="datosTabla.length"
        :per-page="registrosPorPagina"
        aria-controls="my-table1"
      ></b-pagination>
    </div>
    <div
      v-if="datosTabla.length === 0 && !loader"
      class="d-flex justify-content-center align-items-center"
      style="min-height: 30vh"
    >
      <p>No se encontraron resultados</p>
    </div>

    <b-modal v-model="show" :title="tituloModal" size="lg" no-close-on-backdrop>
      <b-container fluid>
        <b-row>
          <b-col>
            <b-form>
              <b-form-group align="left">
                <div v-for="(item, index) of datosFormulario" :key="index">
                  <b-form-group :label="item.valor">
                    <b-form-input
                      :placeholder="item.valor"
                      :type="item.tipoInputHtlm"
                      :minlength="item.minCaracteres"
                      :maxlength="item.maxCaracteres"
                      v-model="item.valorDato"
                      :state="validateState(index)"
                    />
                  </b-form-group>
                  <b-form-invalid-feedback :state="validateState(index)">
                    Este campo es obligatorio
                  </b-form-invalid-feedback>
                </div>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>Selecciona las cuentas:</label>
            <div>
              <v-select
                style="width: 100%"
                :clearable="false"
                :options="lstCuentas"
                v-model="cuentasSeleccionado"
                :reduce="(variable) => variable.idCuenta"
                label="nombreCuenta"
                placeholder="Selecciona las cuentas"
                multiple
              >
                <span slot="no-options">No hay cuentas disponibles</span>
              </v-select>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group align="left">
              <label for="grupos">Seleccione los grupos</label>
              <b-input-group size="sm" class="mb-2">
                <v-select
                  id="grupos"
                  name="grupos"
                  multiple
                  placeholder="Seleccione los grupos"
                  v-model="gruposSeleccionados"
                  label="nombreGrupo"
                  :options="grupos"
                  :reduce="(grupo) => grupo.idGrupo"
                  style="width: 95%"
                ></v-select>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-button
          variant="outline-primary"
          @click="guardaUsuarioPortalAutoservicio()"
        >
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
            <b-spinner small></b-spinner>
            Cargando...
          </span>
        </b-button>
        <b-button variant="outline-danger" @click="cerrarModal()"
          >Cancelar</b-button
        >
      </div>
    </b-modal>
    <b-modal
      v-model="showaAgregar"
      :title="tituloModal"
      size="lg"
      no-close-on-backdrop
    >
      <b-container fluid>
        <span class="text-center" v-if="loaderFormulario">
          <b-spinner small></b-spinner>
          Cargando...
        </span>
        <b-row>
          <b-col>
            <b-form>
              <b-form-group align="left">
                <div v-for="(item, index) of datosFormulario" :key="index">
                  <b-form-group :label="item.valor">
                    <b-form-input
                      :placeholder="item.valor"
                      :type="item.tipoInputHtlm"
                      :minlength="item.minCaracteres"
                      :maxlength="item.maxCaracteres"
                      v-model="item.valorDato"
                      :state="validateState(index)"
                    />
                  </b-form-group>
                  <b-form-invalid-feedback :state="validateState(index)">
                    Este campo es obligatorio
                  </b-form-invalid-feedback>
                </div>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>Selecciona las cuentas:</label>
            <div>
              <v-select
                style="width: 100%"
                :clearable="false"
                :options="lstCuentas"
                v-model="cuentasSeleccionado"
                :reduce="(variable) => variable.idCuenta"
                label="nombreCuenta"
                placeholder="Selecciona las cuentas"
                multiple
              >
                <span slot="no-options">No hay cuentas disponibles</span>
              </v-select>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group align="left">
              <label for="grupos">Seleccione los grupos</label>
              <b-input-group size="sm" class="mb-2">
                <v-select
                  id="grupos"
                  name="grupos"
                  multiple
                  placeholder="Seleccione los grupos"
                  v-model="gruposSeleccionados"
                  label="nombreGrupo"
                  :options="grupos"
                  :reduce="(grupo) => grupo.idGrupo"
                  style="width: 95%"
                ></v-select>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-button
          variant="outline-primary"
          @click="guardaUsuarioPortalAutoservicio()"
        >
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
            <b-spinner small></b-spinner>
            Cargando...
          </span>
        </b-button>
        <b-button variant="outline-danger" @click="cerrarModal()"
          >Cancelar</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    filtro: {
      idSistema: 6,
      palabraClave: null,
      registroActivo: null,
    },
    datosTabla: [],
    fields: [],
    paginaActual: 0,
    registrosPorPagina: 10,
    loader: false,
    tituloModal: "",
    show: false,
    showaAgregar: false,
    usuario: null,
    loaderFormulario: null,
    datosFormulario: [],
    loaderAcciones: false,
    blnGuardarUsuario: false,
    idUsuario: null,
    idUsuarioNSD: null,
    lstCuentas: [],
    cuentasSeleccionado: [],
    grupos: [],
    gruposSeleccionados: [],
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerUsuarioSistemaPortalAutoservicio();
    this.obtenerCuentas();
    this.catalogoGrupo();
  },
  mounted() {
    this.fields = [
      { key: "idUsuario", label: "ID", sortable: true },
      { key: "nombreUsuario", label: "NOMBRE USUARIO", sortable: true },
      { key: "nombreCompleto", label: "NOMBRE COMPLETO", sortable: true },
      { key: "fechaModificacion", label: "FECHA MODIFICACIÓN", sortable: true },
      {
        key: "nombreModificacion",
        label: "NOMBRE USUARIO QUE MODIFICÓ",
        sortable: true,
      },
      "ACCIONES",
    ];
  },
  methods: {
    obtenerUsuarioSistemaPortalAutoservicio() {
      this.loader = true;
      this.datosTabla = [];
      this.$http
        .post(
          this.$api + "admin/portalautoservicio/obtenerUsuarios",
          this.filtro
        )
        .then((respuesta) => {
          if (respuesta.data.data) {
            this.datosTabla = respuesta.data.data;
          }
        })
        .finally(() => {
          this.loader = false;
          this.idUsuairoNSD = null;
          this.idUsuario = null;
        });
    },
    obtenerDatosFormularioPortalAutoservicio() {
      this.datosFormulario = [];
      let datos = {
        idSistema: 6,
        palabraClave: null,
        idUsuario: null,
      };
      this.loaderFormulario = true;
      this.$http
        .post(
          this.$api + "admin/portalautoservicio/obtenerDatosFormulario",
          datos
        )
        .then((respuesta) => {
          if (respuesta.data.data) {
            this.datosFormulario = respuesta.data.data;
          }
        })
        .finally(() => {
          this.loaderFormulario = false;
        });
    },
    activarDesactivarUsuario(item) {
      let datos = {
        idSistema: 6,
        palabraClave: null,
        idUsuario: item.idUsuarioNSD,
      };
      const mensaje = item.registro
        ? "¿Está seguro de desactivar el usuario?"
        : "¿Está seguro de activar el usuario?";
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          this.$http
            .post(
              this.$api + "admin/portalautoservicio/activarDesactivarUsuario",
              datos
            )
            .then((respuesta) => {
              if (respuesta.data.data) {
                item.registro = !item.registro;
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "El usuario se actualizó correctamente",
                });
                this.obtenerUsuarioSistemaPortalAutoservicio();
              }
            });
        }
      });
    },
    modificar(item) {
      this.datosFormulario = [];
      this.cuentasSeleccionado = [];
      this.gruposSeleccionados = [];
      this.datosFormulario = item.listaUsuarioDatos;
      this.cuentasSeleccionado = item.cuentasSeleccionado;
      this.gruposSeleccionados = item.gruposSeleccionados;
      this.idUsuario = item.idUsuario;
      this.idUsuarioNSD = item.idUsuarioNSD;
      this.tituloModal = "Modificar";
      this.show = true;
    },
    agregar() {
      this.obtenerDatosFormularioPortalAutoservicio();
      this.tituloModal = "Agregar Nuevo Usuario";
      this.showaAgregar = true;
      this.cuentasSeleccionado = [];
    },
    guardaUsuarioPortalAutoservicio() {
      this.validateGuardar();
      this.loaderAcciones = true;
      if (this.blnGuardarUsuario) {
        this.loaderAcciones = false;
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: "Revisar los campos son obligatorios, por favor verifique la información",
        });
        return false;
      } else {
        let datos = {
          idUsuario: this.idUsuario,
          nombreUsuario: null,
          contrasenia: null,
          listaUsuarioDatos: this.datosFormulario,
          idSistema: 6,
          idUsuarioNSD: this.idUsuarioNSD,
          forzarCambioContrasenia: null,
          logeoPorToken: null,
          tokenLogeo: null,
          correo: null,
          nombreCompleto: null,
          registroActivo: null,
          fechaModificacion: null,
          idUsuarioModificacion: null,
          nombreModificacion: null,
          cuentasSeleccionado: this.cuentasSeleccionado,
          idCanal: 28,
          gruposSeleccionados: this.gruposSeleccionados,
        };
        this.$http
          .post(this.$api + "admin/portalautoservicio/guardarPorSistema", datos)
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.obtenerUsuarioSistemaPortalAutoservicio();
              this.cerrarModal();
              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: "La operación se realizó correctemente.",
              });
            } else {
              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: "El usuario ya existe.",
              });
            }
          })
          .catch(() => {
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: "Ocurrio un error",
            });
          })
          .finally(() => {
            this.loaderAcciones = false;
          });
      }
    },
    validateState(index) {
      if (this.datosFormulario[index].requerido === true) {
        if (
          this.datosFormulario[index].valorDato !== null &&
          this.datosFormulario[index].valorDato !== ""
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    validateGuardar() {
      this.blnGuardarUsuario = false;
      this.datosFormulario.forEach((d) => {
        if (d.requerido === true) {
          if (d.valorDato === null || d.valorDato === "") {
            this.blnGuardarUsuario = true;
          }
        }
      });
    },
    cerrarModal() {
      this.show = false;
      this.showaAgregar = false;
      this.datosFormulario = [];
      this.idUsuario = null;
    },
    obtenerCuentas() {
      this.blnLoaderPlanes = true;
      this.$http
        .get(this.$api + "portalautoservicio/catalogo/cuentas")
        .then((response) => {
          if (response.data.data) {
            this.lstCuentas = [];
            this.lstCuentas = response.data.data;
          }
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(() => {
          this.blnLoaderPlanes = false;
        });
    },
    catalogoGrupo() {
      this.$http
        .post(this.$api + "portalautoservicio/catalogo/gruposPortal")
        .then((respuesta) => {
          if (respuesta.data.data) {
            this.grupos = respuesta.data.data;
          }
        });
    },
  },
};
</script>
<style scoped>
.icon-boton {
  filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7500%)
    hue-rotate(79deg) brightness(107%) contrast(108%);
}

.card-usuarios {
  border-radius: 25px;
  box-shadow: 3px 4px 7px 2px rgb(110 110 110 / 43%);
  margin: 1vw;
}

.barras {
    border-width: 1px;
    border-style: solid;
    border-color: #C6E9EE;
    background: #ffffff;
    margin-top: 20px;
    padding-right: 1%;
    padding-left: 1%;
    border-radius: 50px;
    text-align: left;
    align-items: center;
}
.botonesAzulFuerteRedondo{
  height: 2em;
  width: 2em;
  border-radius: 50px;
  background-color: #1B81AF;
  border: 1px solid #1B81AF;
}

.botonesAzulFuerteRedondo:hover{
  height: 2em;
  width: 2em;
  border-radius: 50px;
  background-color: #69b8dd;
  border: 1px solid #69b8dd;
}
.btn_busqueda{
  height: 1.7em;
  width: 1.7em;
}
</style>
